<form [formGroup]="form" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">
    <app-companies [defaultValue]="defaultData?.company" class="w-full" (valueState)="setCompany($event)" ></app-companies>
    @for (item of dataInputs(); track $index) {
        <app-input class="w-full"
            [config]="item"
            (submitValue)="handleValue($event)">
        </app-input>
    }

    <app-selected class="w-full"
        [config]="dataSelected().at(0)"
        (selectValue)="handleValue($event)"
    ></app-selected>

    <!-- Se quito el Reset Timer a este componente -->
    <app-profession class="w-full" [defaultValue]="defaultData?.codpro" (valueState)="onProfessionSelected($event)"></app-profession>

    <app-selected class="w-full"
        [config]="dataSelected().at(1)"
        (selectValue)="handleValue($event)"
    ></app-selected>

    <!-- {{ form.value | json }} -->
</form>